module.exports = __webpack_public_path__ + "static/media/about__choose_leads.0b0094dc.png";